import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('figma-prototype-respondent-path', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('figma-prototype-respondent-path');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
